<template>
    <div class="container">
        <b-modal
            :model-value="showDialogEdit"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-user-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.formInfoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.formInfoSubtitle }}</div>
                </div>

                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group @submit.prevent="editaInfoUser">
                        <label class="form-label">{{ labels.name }}</label>
                        <b-form-input 
                            v-model="formEdit.nameUser" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Nombre completo"
                        ></b-form-input>

                        <label class="form-label mt-3">{{ labels.identificationCard }}</label>
                        <b-form-input 
                            v-model="formEdit.cedula" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Número de cédula"
                        ></b-form-input>

                        <label class="form-label mt-3">{{ labels.email }}</label>
                        <b-form-input 
                            v-model="formEdit.correo" 
                            type="email" 
                            class="form-input" 
                            autocomplete="new-password"
                            placeholder="correo@ejemplo.com"
                        ></b-form-input>

                        <label class="form-label mt-3">{{ labels.phone }}</label>
                        <b-form-input 
                            v-model="formEdit.phone" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Número de teléfono"
                        ></b-form-input>

                        <label class="form-label mt-3">{{ labels.role }}</label>
                        <b-form-select v-model="formEdit.id_rol" class="form-input">
                            <option value="" disabled>Selecciona un rol</option>
                            <option v-for="rol in listaRol" :key="rol?.id" :value="rol?.id">{{ rol?.nombre }}</option>
                        </b-form-select>

                        <label class="form-label mt-3">{{ labels.passw }}</label>
                        <b-form-input 
                            v-model="formEdit.password" 
                            type="password" 
                            class="form-input" 
                            autocomplete="new-password"
                            placeholder="Mínimo 8 caracteres"
                        ></b-form-input>
                    </b-form-group>

                    <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                        <b-button class="mr-2 reset-btn-secondary" @click="cierraModal()">{{ labels.close }}</b-button>
                        <b-button class="reset-btn-primary" @click="editaInfoUser()">{{ labels.save }}</b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Roles from '../../services/Roles';
import User from '../../services/User';

export default {
    name: "EditarUser",
    props: ['showDialogEdit', 'formEdit'],
    data: () => ({
        listaRol: [],
        error: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar usuario",
                    save: "Guardar",
                    close: "Cerrar",
                    name: "Nombre completo",
                    identificationCard: "Cédula",
                    email: "Correo electrónico",
                    phone: "Teléfono",
                    role: "Rol",
                    passw: "Contraseña",
                    formInfoTitle: "Datos del usuario",
                    formInfoSubtitle: "Actualiza la información del usuario y guarda los cambios."
                }
            } else {
                return {
                    title: "Edit user",
                    save: "Save",
                    close: "Close",
                    name: "Full name",
                    identificationCard: "Identification card",
                    email: "Email",
                    phone: "Phone",
                    role: "Role",
                    passw: "Password",
                    formInfoTitle: "User information",
                    formInfoSubtitle: "Update user information and save changes."
                }
            }
        }
    },
    methods: {
        cierraModal() {
            this.$emit('cierraModal', false)
        },
        editaInfoUser() {
            if (!this.formEdit.nameUser) {
                this.$toast.error("Diligenciar el nombre")
                return
            }
            if (!this.formEdit.correo) {
                this.$toast.error("Diligenciar el correo")
                return
            }
            if (!this.formEdit.id_rol) {
                this.$toast.error("Seleccionar el rol")
                return
            }

            User.updateUser(this.formEdit)
                .then(() => {
                    this.$toast.success("Usuario editado correctamente")
                    this.$emit('updated', {
                        id: this.formEdit.idUser,
                        nombre: this.formEdit.nameUser,
                        email: this.formEdit.correo,
                        cedula: this.formEdit.cedula,
                        telefono: this.formEdit.phone,
                        id_rol: this.formEdit.id_rol
                    })
                    this.cierraModal()
                })
                .catch(() => {
                    this.error = true
                    this.$toast.error("No se pudo editar el usuario")
                })
        }
    },
    mounted() {
        Roles.getAllRoles()
            .then((res) => {
                this.listaRol = res.data.roles
            })
            .catch((err) => {
                console.log(err)
            })
    }
}
</script>